import { fetchJSON } from "./utils";

const BASE_URL = '/api/connect'

export async function connectUser(data) {
  const url = `${BASE_URL}/users`;
  return fetchJSON(url, null, data, "put");
}

export async function agentToUser(data) {
  const url = `${BASE_URL}/agent`;
  return fetchJSON(url, null, data, "put");
}
